import { render, staticRenderFns } from "./HgFarmerPopView.vue?vue&type=template&id=41918f2a&scoped=true"
import script from "./HgFarmerPopView.vue?vue&type=script&lang=js"
export * from "./HgFarmerPopView.vue?vue&type=script&lang=js"
import style0 from "./HgFarmerPopView.vue?vue&type=style&index=0&id=41918f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41918f2a",
  null
  
)

export default component.exports